import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import NotFound from "./components/NotFound";
import GuestLayout from "./GuestLayout";
import Layout from "./Layout";
import { auth, global, guest } from "./routes";

const ProtectedRoute = ({ type, user, redirectTo, children }) => {
  return (type === "auth" && user && user.isLoggedIn) ||
    (type === "guest" && (!user || !user.isLoggedIn)) ? (
    children
  ) : (
    <Navigate to={redirectTo} replace />
  );
};

const Router = ({ user }) => {
  const [routes, setRoutes] = React.useState([]);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const globalRoutes = Object.keys(global).map((key) => (
      <Route
        key={global[key].id}
        path={global[key].link}
        element={
          <Layout title={global[key].name}>
            {React.createElement(global[key].property)}
          </Layout>
        }
        exact={global[key].exact}
      >
        {global[key].pages &&
          global[key].pages.map((page) => {
            return page.isIndex ? (
              <Route
                key={page.id}
                element={React.createElement(page.property)}
                index
                exact={page.exact}
              />
            ) : (
              <Route
                key={page.id}
                path={page.link}
                element={React.createElement(page.property)}
                exact={page.exact}
              />
            );
          })}
      </Route>
    ));

    const authRoutes = Object.keys(auth).map((key) => (
      <Route
        key={auth[key].id}
        path={auth[key].link}
        element={
          <ProtectedRoute type="auth" user={user} redirectTo={guest.login.link}>
            <Layout title={auth[key].name}>
              {React.createElement(auth[key].property)}
            </Layout>
          </ProtectedRoute>
        }
        exact={auth[key].exact}
      >
        {auth[key].pages &&
          auth[key].pages.map((page) => {
            return page.isIndex ? (
              <Route
                key={page.id}
                element={React.createElement(page.property)}
                index
                exact={page.exact}
              />
            ) : (
              <Route
                key={page.id}
                path={page.link}
                element={React.createElement(page.property)}
                exact={page.exact}
              />
            );
          })}
      </Route>
    ));
    const guestRoutes = Object.keys(guest).map((key) => (
      <Route
        key={guest[key].id}
        path={guest[key].link}
        element={
          <ProtectedRoute
            type="guest"
            user={user}
            redirectTo={auth.dashboard.link}
          >
            <GuestLayout title={guest[key].name}>
              {React.createElement(guest[key].property)}
            </GuestLayout>
          </ProtectedRoute>
        }
        exact={guest[key].exact}
      >
        {guest[key].pages &&
          guest[key].pages.map((page) => {
            return page.isIndex ? (
              <Route
                key={page.id}
                element={React.createElement(page.property)}
                index
                exact={page.exact}
              />
            ) : (
              <Route
                key={page.id}
                path={page.link}
                element={React.createElement(page.property)}
                exact={page.exact}
              />
            );
          })}
      </Route>
    ));

    setRoutes([...globalRoutes, ...authRoutes, ...guestRoutes]);
  }, [user]);

  React.useEffect(() => setIsReady(Boolean(routes.length)), [routes]);

  return (
    isReady && (
      <Routes>
        {routes.map((route) => route)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    )
  );
};

export default Router;
